// extracted by mini-css-extract-plugin
export default {"rotate":"Progress-rotate-f9c4"};